import styled from 'styled-components'
import { layout } from '../../styles/GlobalVariables'
import { Ad } from '../../sharedComponents'
import AdPlacementCss from '../Ads/AdPlacementCss'

export const StyledPWithADWrap = styled.div`
  margin-bottom: ${layout.gapMedium};

  [id*='google_ads_iframe'],
  [id*='In_article_box'] {
    text-align: center;
  }
`
export const StyledInArticleBox = styled(Ad)`
  ${AdPlacementCss({ width: 300, height: 250 })}
`
